/**
 * FlagImg — imagen de bandera desde flagcdn.com
 * Uso: <FlagImg code="mx" size={20} />
 */
import React from 'react';

const CODES = {
  mx: 'mx',
  us: 'us',
  ca: 'ca',
};

export function FlagImg({ code, size = 20, style = {}, className }) {
  const cc = CODES[code] || code;
  return (
    <img
      src={`https://flagcdn.com/w40/${cc}.png`}
      srcSet={`https://flagcdn.com/w80/${cc}.png 2x`}
      width={size * 1.5}
      height={size}
      alt={cc.toUpperCase()}
      style={{
        objectFit: 'cover',
        borderRadius: 3,
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0,
        ...style,
      }}
      className={className}
    />
  );
}
